<template>
  <div class="module-content">
    <div class="edit-editor-content">
      <el-form ref="editModule" :model="formData" :rules="rules">
        <div class="position-r" >
          <div class="edit-module-item-name margin-top-24">作品名称</div>
          <el-form-item>
            <el-input placeholder="请输入作品名称" class="slect-input-auto-main" v-model="formData.title" maxlength="20" />
          </el-form-item>
        </div>
        <div class="position-r" >
          <div class="edit-module-item-name margin-top-24">作品链接</div>
          <el-form-item>
            <el-input placeholder="请粘贴作品链接" class="slect-input-auto-main" v-model="formData.url" />
          </el-form-item>
        </div>
        <div class="position-r" >
          <div class="edit-module-item-name margin-top-24"><span style="color:#ff6644">*</span> 作品二维码<span style="color:#9c9c9c">（线下投递 HR 可通过扫码查看作品集）</span></div>
          <div class="qrcode-box">
            <input type="file" accept="image/*" class="up-input" ref="upInput" @change="upInputChange">

            <img class="qrcode-img" :src="formData.qrcode" v-if="formData.qrcode" @click="upButton">
            <div class="qrcode iconfont iconplus" @click="upButton" v-else></div>

            <div class="module-delete" @click="$emit('deleteExperience')" v-show="experienceInfos">
              <i class="iconfont icontrash-"></i>
              <span>删除这段经历</span>
            </div>
          </div>
        </div>

      </el-form>
    </div>
    <!-- 裁剪 -->
    <crop-picture
      title='作品二维码' :img='imgUrl'
      v-if="showCropPicture" @uploadConfirm="uploadConfirm"
    />
  </div>
</template>

<script>
	import degree from '@/assets/json/degree'
	import { mapState, mapMutations } from 'vuex'
    // 上传图片
  import cropPicture from '~/components/block/crop-picture';

	export default {
		name: 'w-form-data',
		props: {
			formData: {
				type: Object,
				default: () => {
					return {
            present:'',
          }
				}
			},
			moduleType: {
				type: [ String, Number ],
				default: ''
			},
      experienceInfos:{
        type: Array,
				default: () => []
      }
		},
		data () {
			const ruleUrl = (rule, value, callback) => {
        if(!this.formData.url){
          callback()
          return
        }
				// if (!this.formData.url.includes('http')) {
				// 	return callback(new Error('请填写正确的作品链接'))
				// }
				callback()
			}
			return {
				// 验证规则
				rules: {
					url: [
						{ validator: ruleUrl, trigger: 'blur' }
					],
        },
        showCropPicture: false, //是否显示图片裁剪
        imgUrl: '',
        maxImgSize: 2*1024*1024, //最大上传图片大小（file表单）
			}
		},
		mounted () {
		},
		computed: {
			...mapState('editor', [ 'suggestInfo','cvDetail', 'currentInfo' ]),
		},
		watch: {},
		components: {
      cropPicture
		},
		methods: {
			...mapMutations('editor', [ 'setSuggestInfo' ]),
			// 表单的校验规则
			formValidate () {
				let flag = false
				this.$refs['editModule'].validate(valid => {
					flag = valid
				})
				return flag
			},
			// 优化简历关闭
			handleClose () {
				this.setSuggestInfo({})
      },

      //点击上传图片
      upButton() {
        this.$refs.upInput.click();
      },
      //上传图片检测
      upInputChange(data) {
        let file = this.$refs.upInput.files;
        let fileType = file[0].type.toLowerCase();
        //判断文件类型
        if(!(fileType==='image/png' || fileType==='image/jpg' || fileType==='image/jpeg')){
          this.$message({
            message: '上传作品二维码格式错误',
            type: 'warning'
          });
          this.$refs.upInput.value = '';
          return false;
        }
        //判断图片大小
        if(file[0].size> this.maxImgSize){
          this.$message({
            message: '上传作品二维码大小超出限制',
            type: 'warning'
          });
          this.$refs.upInput.value = '';
          return false;
        }
        const reader = new FileReader()
        reader.readAsDataURL(file[0])
        reader.onload = e => {
          this.showCropPicture = true
          this.imgUrl = e.currentTarget.result
        }
      },
      //上传图片成功
      uploadConfirm(value) {
        this.$refs.upInput.value = '';
        this.showCropPicture = false
        if(value){
          this.formData.qrcode = value
          this.$emit('updateFormData', this.formData)
        }
      },
      
		}
	}
</script>

<style lang="scss" scoped>
  .edit-module-edu-main {
    padding: 0 28px;
    .edu-menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edu-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        cursor: pointer;
        .edu-item-select {
          width: 16px;
          height: 16px;
          border: 1px solid #DEDFE1;
          margin-right: 12px;
          text-align: center;
          line-height: 16px;
          &.active {
            .iconfont {
              font-size: 14px;
              margin: auto;
            }
          }
        }
        .iconfont {
          margin-right: 8px;
        }
      }
    }
  }
  .qrcode-box {
    overflow: hidden;
    .qrcode{
      width: 98px;
      height: 98px;
      border-radius: 4px;
      border: 1px solid #ECECEC;
      font-size: 32px;
      text-align: center;
      line-height: 98px;
      color: #ECECEC;
      float: left;
      cursor: pointer;
      &:hover{
        border-color: #CFCFCF;
        color: #CFCFCF;
      }
    }
    .qrcode-img{
      display: block;
      width: 100px;
      height: 100px;
      float: left;
      cursor: pointer;
      border-radius: 4px;
    }
    .up-input {
      width: 0;
      height: 0;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    .module-delete{
      float: right;
      margin-top: 65px;
    }
  }
</style>
